import { type ReactElement, type ReactNode } from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

/**
 * Tooltip — Radix tooltip wrapped to DS tokens. Self-contained provider so
 * it can be dropped in anywhere. The child is the trigger and must be a single
 * focusable element (so the tooltip is reachable by keyboard).
 */
export function Tooltip({
  label,
  children,
}: Readonly<{ label: ReactNode; children: ReactElement }>): React.JSX.Element {
  return (
    <TooltipPrimitive.Provider delayDuration={200}>
      <TooltipPrimitive.Root>
        <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            sideOffset={6}
            className="z-50 max-w-xs rounded-md border border-border bg-card px-2.5 py-1.5 text-meta leading-snug text-foreground shadow-md data-[state=delayed-open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=delayed-open]:fade-in-0"
          >
            {label}
            <TooltipPrimitive.Arrow className="fill-card" />
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
}
